import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const DIAGRAM_COPY = {
  en: {
    title: "Candle Element Construction & Radial Inflow Geometry",
    lead: "High-collapse resistance-welded wedge wire tube cross-section with inward-widening slots for backpulse cake discharge."
  },
  zh: {
    title: "烛式滤芯全焊结构截面与反吹脱饼原理",
    lead: "高抗压溃全焊式楔形丝圆柱截面，向内扩散的微米级自释放通道可实现气脉冲快速彻底脱饼。"
  },
  es: {
    title: "Construcción del Elemento Bujía y Geometría Radial",
    lead: "Sección transversal de tubo de alambre en cuña soldado con ranuras que se ensanchan hacia el interior para retrolavado ágil."
  },
  de: {
    title: "Spaltfilterkerzen-Aufbau & Radiale Geometrie",
    lead: "Kollapsfester widerstandsgeschweißter Spaltrohrquerschnitt mit sich nach innen erweiterndem Spalt für schnellen Kuchenabwurf."
  },
  fr: {
    title: "Construction de la Bougie Filtrante et Écoulement Radial",
    lead: "Coupe transversale en fil profilé résistant à l'écrasement avec fente s'élargissant vers l'intérieur pour un décolmatage aisé."
  },
  pt: {
    title: "Construção do Elemento Vela e Geometria Radial",
    lead: "Seção transversal eletrosoldada resistente ao colapso com fenda alargada internamente para desprendimento rápido da torta."
  }
};
export default function WedgeWireTubesPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = pick(lang, DIAGRAM_COPY);
  const diagram = <DiagramSection id="wedge-wire-tubes-diagram" title={diagramCopy.title} lead={diagramCopy.lead} tone="muted">
      <div className="max-w-xl mx-auto">
        <WedgeWireProfileDiagram variant="cylinder" />
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}